module.exports = __webpack_public_path__ + "img/logo.f04bf8be.png";